import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { arrayOf, bool, shape } from 'prop-types';
import * as R from 'ramda';
import { EmptyCard } from 'common';

import SourceLocationCard from './SourceLocationCard';
import Header from './Header';
import NoSourceLocationsAvailable from './NoSourceLocationsAvailable';

const MainPanel = props => {
  const { isFetching, sourceLocations } = props;
  return (
    <Box
      sx={{
        marginLeft: { lg: '395px' },
        marginTop: 6,
        pb: 10,
      }}
    >
      <Header />
      {isFetching && (
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            // eslint-disable-next-line sort-keys-fix/sort-keys-fix
            left: { xs: 'calc(50% - 80px)', lg: '59%' },
            position: 'absolute',
            top: 'calc(50% - 48px)',
          }}
        >
          <CircularProgress size={48} />
          <Typography sx={{ color: 'text.primary', ml: 1 }} variant="h5">
            Loading...
          </Typography>
        </Box>
      )}
      {R.and(R.not(isFetching), R.isNil(sourceLocations)) && (
        <EmptyCard
          subtitle="Select a Product, Destination(s) and filters to search and see your available source locations."
          title="Which Source Locations are you searching for?"
        />
      )}
      {R.and(R.not(isFetching), R.equals(R.length(sourceLocations), 0)) && (
        <NoSourceLocationsAvailable />
      )}
      {sourceLocations?.map(sourceLocation => (
        <SourceLocationCard
          key={`${R.path(['fromLocation', 'locationId'], sourceLocation)}${R.prop(
            'productVolume',
            sourceLocation
          )}`}
          sourceLocation={sourceLocation}
        />
      ))}
    </Box>
  );
};

MainPanel.propTypes = {
  isFetching: bool.isRequired,
  sourceLocations: arrayOf(shape({})),
};

MainPanel.defaultProps = {
  sourceLocations: null,
};

export default MainPanel;
